<div (clickOutside)="clickedOutside()">
    <form
        #searchForm
        action="{{ searchResultPageUrl$ | async }}"
        autocomplete="off"
        (ngSubmit)="canSubmit($event)"
        [ngClass]="{
            'mode-header': config.theme === 'HEADER',
            'mode-page': config.theme === 'PAGE',
            'mode-nobutton': config.theme === 'NOBUTTON',
            'mode-footer': config.theme === 'FOOTER',
            'mode-filter': config.theme === 'FILTER',
            'is-mobile': isMobileMode,
            'is-mobile-open': isMobileOpen
        }"
    >
        <label [for]="componentId" class="hidden" tabindex="-1">{{ config.label }}</label>
        <div>
            <input
                #searchInput
                type="text"
                name="s"
                aria-labelledby=""
                [placeholder]="config.placeholder ? config.placeholder : ('SearchWidget-Placeholder' | translate)"
                [id]="componentId"
                (keydown)="listFocus($event)"
                (keyup)="onKeyUpEvent($event)"
                (focus)="resultsHidden = false; triggerFocus()"
                (blur)="triggerBlur()"
                tabindex="0"
                (keyup.enter)="submitForm()"
            />
            <ng-container *ngIf="showClearButton$ | async">
                <button da-button [themeType]="noTheme" class="search_clear" type="button" (click)="clear()"></button>
            </ng-container>
            <ng-container *ngIf="showDropDownButton$ | async">
                <button da-button [themeType]="noTheme" class="search_clear search_dropdown" type="button" (click)="focus()"></button>
            </ng-container>
            <button
                da-button
                [themeType]="noTheme"
                type="button"
                (click)="submitForm()"
                [ngClass]="{
                    primary:
                        config.theme === 'FILTER' || config.theme === 'HEADER' || config.theme === 'PAGE' || config.theme === 'NOBUTTON',
                    secondary: config.theme === 'FOOTER'
                }"
            ></button>
        </div>
        <div *ngIf="hiddenFields$ | async as hiddenFields">
            <input *ngFor="let hiddenField of hiddenFields" type="hidden" [name]="hiddenField.key" [value]="hiddenField.value" />
        </div>
    </form>

    <ng-container *ngIf="results$ | async as results">
        <div
            class="result-list"
            *ngIf="results.length && !resultsHidden"
            [ngStyle]="{ 'width.px': inputWidth$ | async }"
            [ngClass]="{
                'mode-header': config.theme === 'HEADER',
                'mode-page': config.theme === 'PAGE',
                'mode-nobutton': config.theme === 'NOBUTTON',
                'mode-footer': config.theme === 'FOOTER',
                'mode-filter': config.theme === 'FILTER'
            }"
        >
            <ng-container *ngIf="config.theme === 'NOBUTTON' && results.length > config.displayMaxResults">
                <span [innerHtml]="'ProductOrderInformationSection-SearchAreaTooManyResults' | translate"></span>
            </ng-container>
            <ng-container
                *ngIf="
                    config.theme !== 'NOBUTTON' ||
                    (config.theme === 'NOBUTTON' && results.length <= config.displayMaxResults && results.length > 0)
                "
            >
                <ng-container
                    *ngFor="let result of results | slice: 0:config.displayMaxResults; let _first = first; let _last = last; let i = index"
                >
                    <da-acs-list-item-v3
                        *ngIf="config.showAllResultsLink && config.theme === 'FOOTER' && _first"
                        [item]="showAllResultsLinkData"
                    >
                        <ng-container *ngTemplateOutlet="showAllResults"></ng-container>
                    </da-acs-list-item-v3>
                    <da-acs-list-item-v3
                        [item]="result"
                        (click)="submitForm(result)"
                        tabindex="0"
                        id="element{{ i }}"
                        (keydown)="listFocusNext($event)"
                        [innerHTML]="highlightSearchTerm(result)"
                        class="search-element"
                        (keyup.enter)="submitForm()"
                    ></da-acs-list-item-v3>
                    <da-acs-list-item-v3
                        *ngIf="config.showAllResultsLink && (config.theme === 'HEADER' || config.theme === 'NOBUTTON') && _last"
                        [item]="showAllResultsLinkData"
                    >
                        <ng-container *ngTemplateOutlet="showAllResults"></ng-container>
                    </da-acs-list-item-v3>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="(results$ | async)?.length === 0 && config.theme === 'NOBUTTON'">
        <div class="result-list mode-nobutton" *ngIf="!resultsHidden" [ngStyle]="{ 'width.px': inputWidth$ | async }">
            <span [innerHtml]="'ProductOrderInformationSection-SearchAreaNoResults' | translate"></span>
        </div>
    </ng-container>
</div>

<ng-template #showAllResults>
    <a da-link class="show-all-results-link" [href]="getSearchAllHref()" icon="drg-icon-arrow_level_down" [tabIndex]="0">
        {{ config.showAllPlaceholder ? config.showAllPlaceholder : ('SearchWidget-showall' | translate) }}
    </a>
</ng-template>
